import { vOnClickOutside } from '@vueuse/components';


export default {
  __name: 'UiDrawer',
  props: {
  value: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: 'Filter title',
  },
},
  emits: ['input'],
  setup(__props, { emit }) {





const close = () => {
  emit('input', false);
};

return { __sfc: true,emit, close, vOnClickOutside }
}

}